import { CircularProgress, Paper, Toolbar, Typography } from '@material-ui/core';
import React from 'react';
import Layout from '../../../common/components/Layout';
import ReturnButton from '../../../common/components/ReturnButton';
import { SimpleBreadcrumbs } from '../../../common/components/SimpleBreadcrumbs';
import { getProject } from '../../../common/services/project';
import { getAffiliationScope } from '../typings';
import { BroadcastAffiliationEditForm } from './BroadcastAffiliationEditForm.component';
import { IComponentProps } from './BroadcastAffiliationDetail.connector';

export class BroadcastAffiliationDetail extends React.Component<IComponentProps> {
  public componentDidMount() {
    this.fetchData();
  }

  public render() {
    const {
      affiliation,
      fetching,
      intl: { messages: m },
    } = this.props;

    if (fetching) {
      return <CircularProgress size={100} style={{ width: 100, margin: 'auto' }} />;
    }

    if (!affiliation) {
      return <div>{m.error_noData}</div>;
    }

    const channelName = affiliation.channel ? affiliation.channel.name : '-';
    const displayLabel = affiliation.useLabel && affiliation.label ? affiliation.label : channelName;
    const scope = getAffiliationScope(affiliation.targets);

    return (
      <Layout
        id="broadcast-affiliation-detail-layout"
        top={
          <SimpleBreadcrumbs
            crumbStack={[
              { labelKey: 'app_broadcastAffiliations', href: `#${getProject().url}/broadcast-affiliations` },
              { label: displayLabel },
            ]}
          />
        }
        main={
          <Paper elevation={2}>
            <Toolbar>
              <div>
                <Typography variant="h6">
                  {displayLabel} · {scope}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {affiliation.id}
                </Typography>
              </div>
              <div style={{ flex: 1 }} />
              <ReturnButton entity="broadcast-affiliations" />
            </Toolbar>
            <BroadcastAffiliationEditForm
              affiliation={affiliation}
              onSave={this.handleSave}
              onDelete={this.handleDelete}
            />
          </Paper>
        }
      />
    );
  }

  private handleSave = (payload: object) => {
    this.props.updateBroadcastAffiliation(this.props.id, payload);
  };

  private handleDelete = (id: string) => {
    this.props.deleteBroadcastAffiliation(id);
    this.props.history.push(`${getProject().url}/broadcast-affiliations`);
  };

  private fetchData = () => {
    const { id, fetchBroadcastAffiliation } = this.props;
    fetchBroadcastAffiliation(id);
  };
}
